import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { HydraTable, SelectFilter, TimeAgo } from '@peracto/peracto-ui'
import { useConfig } from '@peracto/peracto-config'

import { GET_LIST, useClient } from '@peracto/client'
import { LOCATION_TYPE_OPTIONS } from '../../util'

const LocationsImportList = () => {
    const { client } = useClient()
    const config = useConfig()
    const formatDate = config.get('user_format_date', config.get('format_date'))

    const columns = useMemo(() => [
        {
            Header: 'Import Type',
            accessor: 'importType',
            Filter: props => (
                <SelectFilter label="Import Type" options={LOCATION_TYPE_OPTIONS} {...props} />
            ),
            Cell: ({ row, cell: { value } }) => (
                <Link to={`/locations/import/${row.original.originId}`}>
                    {LOCATION_TYPE_OPTIONS.find(type => type.value === value).label || '-'}
                </Link>
            ),
        },
        {
            Header: 'Processed',
            accessor: 'processedCount',
        },
        {
            Header: 'Errors',
            accessor: 'errorCount',
        },
        {
            Header: 'Total',
            accessor: 'totalCount',
        },
        {
            Header: 'Created By',
            accessor: 'user.email',
            id: 'createdBy',
            Cell: ({ cell: { value } }) => value || '-',
        },
        {
            Header: 'Created',
            accessor: 'createdAt',
            Cell: ({ cell: { value } }) => {
                const date = new Date(value)
                const validDate = !!date.getDate() === true

                return value && validDate ? <TimeAgo title={formatDate(date)} date={date} /> : '-'
            },
        },
        {
            Header: '% Complete',
            id: 'percentComplete',
            Cell: ({ row }) =>
                row.original.totalCount > 0
                    ? `${Math.round(
                          (row.original.processedCount / row.original.totalCount) * 100
                      )}%`
                    : '-',
        },
    ])

    const onFetchData = options =>
        client(GET_LIST, 'imports', {
            ...options,
            filter: {
                importType: LOCATION_TYPE_OPTIONS.map(type => type.value),
                ...options.filter,
            },
        })

    return (
        <HydraTable
            columns={columns}
            onFetchData={onFetchData}
            noResultsMessage="No location data has been imported"
            fixedRowCount={10}
            nestedTable={true}
        />
    )
}

export default LocationsImportList
